import * as React from 'react'
import type { ENTITY_TYPES } from '@sales-center/common'
import { ActivityHistory } from '@user/features/Activity/ActivityHistory/components/ActivityHistory'
import { useHandlers } from './hooks/useHandlers'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { useTheme } from '@mui/material/styles'

type Props = {
  entityId: number
  entityType: ENTITY_TYPES
  servicesCount: number
  agreementsCount: number
  paymentsCount: number
  appointments: any[]
  salesFunnelStageId: number
  assigneeId: string | null
}

export function ActivityTimelineCard(props: Props) {
  const { onHideAllClick, onShowAllClick } = useHandlers()
  const theme = useTheme()
  return (
    <Stack>
      <Box width="100%">
        <Box mb={2}>
          <Stack direction="row">
            <Stack
              pl="20px"
              pt="20px"
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              width="100%"
            >
              <Typography variant="h6" color={theme.palette.text.primary}>
                Activity Timeline
              </Typography>
            </Stack>
          </Stack>
          {/* ========== FUTURE DEVELOPMENT ========== */}
          <Stack direction="row" pl="20px">
            <Box>
              <Button
                onClick={onShowAllClick}
                variant="text"
                data-test-id="activityTimelineSelectAllButton"
              >
                Select All
              </Button>
              <Button
                onClick={onHideAllClick}
                variant="text"
                data-test-id="activityTimelineDeselectAllButton"
              >
                Deselect All
              </Button>
            </Box>
          </Stack>
          <Stack p={2} width="100%">
            <ActivityHistory {...props} />
          </Stack>
        </Box>
      </Box>
    </Stack>
  )
}
